import "../../App.scss";
import "./landing.scss";
import React, { useEffect } from "react";
import Banner from "./main-banner/Banner.js";
import Header from "./Header/Header.js";
import Specialities from "./Specialities/Specialities.js";
import Choose from "./Choose/Choose.js";
import Product from "./Product/Product.js";
import Contactus from "./Contactus/Contactus.js";
import Footer from "./Footer/Footer.js";

function Landing() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="lp">
      <Header />
      <div id="home" className="lp-top">
        <div className="lp-top__grid" aria-hidden="true" />
        <img
          className="lp-top__fade"
          src="/assets/figma/hero-ellipse.svg?v=1"
          alt=""
          aria-hidden="true"
        />
        <div className="lp-top__nav-slot" aria-hidden="true" />
        <Banner />
      </div>
      <Specialities />
      <Choose />
      <Product />
      <Contactus />
      <Footer />
    </div>
  );
}

export default Landing;
